import { ExternalLink, ArrowRight, MailIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useCancellationPlan } from 'src/context/billing';
import env from 'env';

import CallToActionBanner from './CallToActionBanner';

const PlanUsageWarning = () => {
  const {
    ui: { setStep },
  } = useCancellationPlan();

  const onExploreSolutions = () => window.open('https://codekeeper.co/solutions', '_blank');

  const onContactUs = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');

  const onReviewAccountUse = () => setStep('review-account-usage');

  return (
    <div className="space-y-3">
      <CallToActionBanner
        title="Review account use"
        description="See which products or assets are still active and what you need to complete before canceling."
        action={
          <Button variant="outline" onClick={onReviewAccountUse} size="sm">
            Review account use <ArrowRight />
          </Button>
        }
        variant="secondary"
      />
      <CallToActionBanner
        title="Explore other plans"
        description="If your current plan doesn't fit your needs, explore our other products designed for different use cases and budgets."
        action={
          <Button variant="outline" onClick={onExploreSolutions} size="sm">
            Explore products <ExternalLink />
          </Button>
        }
        variant="secondary"
      />
      <CallToActionBanner
        title="Need some help?"
        description="If you're experiencing issues with the Codekeeper application or any of your solutions, contact us. We're here to help."
        action={
          <Button variant="secondary" onClick={onContactUs}>
            <MailIcon /> Contact us
          </Button>
        }
      />
    </div>
  );
};

export default PlanUsageWarning;
